// DigitalOcean Client - NOW PROXIES TO SUPABASE
// This file maintains the same API but routes all calls through Supabase
// This allows gradual migration without breaking existing code

import { supabase } from "@/integrations/supabase/client";

class DigitalOceanClient {
  // Auth - now proxies to Supabase Auth
  auth = {
    getSession: async () => {
      return supabase.auth.getSession();
    },
    
    getUser: async () => {
      return supabase.auth.getUser();
    },
    
    signUp: async ({ email, password, options }: any) => {
      return supabase.auth.signUp({
        email,
        password,
        options: {
          emailRedirectTo: options?.emailRedirectTo,
          data: options?.data,
        },
      });
    },
    
    signInWithPassword: async ({ email, password }: any) => {
      return supabase.auth.signInWithPassword({ email, password });
    },
    
    signOut: async () => {
      // Clear legacy localStorage items
      if (typeof window !== 'undefined') {
        window.localStorage.removeItem('auth_token');
        window.localStorage.removeItem('auth_user');
      }
      return supabase.auth.signOut();
    },
    
    updateUser: async (updates: any) => {
      return supabase.auth.updateUser(updates);
    },
    
    onAuthStateChange: (callback: (event: string, session: any) => void) => {
      return supabase.auth.onAuthStateChange(callback);
    },
  };

  // Supabase-style query builder - now proxies directly to Supabase
  from(table: string) {
    return supabase.from(table as any);
  }

  // Realtime channels - now uses Supabase realtime
  channel(channelName: string) {
    return supabase.channel(channelName);
  }

  removeChannel(channel: any) {
    if (channel) {
      return supabase.removeChannel(channel);
    }
  }

  // RPC methods - now uses Supabase RPC
  async rpc(functionName: string, params?: any): Promise<{ data: any; error: any }> {
    return supabase.rpc(functionName as any, params);
  }

  // Storage - now uses Supabase Storage
  storage = {
    from: (bucket: string) => supabase.storage.from(bucket),
    listBuckets: async () => supabase.storage.listBuckets(),
  };

  // Functions - now uses Supabase Functions
  functions = {
    invoke: async (functionName: string, options?: any) => {
      return supabase.functions.invoke(functionName, options);
    },
  };
}

// Export the client instance
export const digitalOcean = new DigitalOceanClient();

// Also export the class for cases where a fresh instance is needed
export { DigitalOceanClient };
